import React, { ReactElement } from 'react'
import { BasketModel, ShippingClassModel } from './types/models'
import phone from './assets/phone.svg'

type DeliverySurchargeWarningProps = {
  basket: BasketModel;
  shippingClass: ShippingClassModel;
  shippingQuoteNeeded: boolean;
}

const DeliverySurchargeWarning = ({
  basket,
  shippingClass,
  shippingQuoteNeeded
}: DeliverySurchargeWarningProps): ReactElement => {
  const warnDeliverySurcharge = (): boolean => {
    if (shippingQuoteNeeded) {
      return true
    }
    if (shippingClass) {
      return parseFloat(basket.total_ex_tax) > 1000 &&
        !(shippingClass.is_collection || shippingClass.is_mainland)
    }
    return false
  }

  if (!warnDeliverySurcharge()) {
    return null
  }

  return (
    <>
      <br style={{ clear: 'right' }}/>
      <div className="delivery-surcharge-warning group">
        <a className="call-now" href="tel:01274875479">
          <img loading="lazy" width="24" height="18" src={phone} alt="" className="icon" />
          &nbsp;01274 875479
        </a>
        <h3>Delivery charges</h3>
        <p>
          Sometimes we have to charge a bit more for delivering orders that are particularly
          heavy, or long, or that must go to offshore areas.
          If this is the case we will contact you to agree an amended delivery charge.
        </p>
        { shippingQuoteNeeded
          ? (
          <p><b>
            Based on your delivery destination we will provide you a shipping charge after you have
            placed your order. You may cancel your order if you are unhappy with the quoted charge.
          </b></p>
            )
          : (
          <div className="smallPrint">
            We reserve the right to change delivery charges.
            You may cancel your order if you are unhappy with the amended charge.
          </div>
            )}
      </div>
    </>
  )
}

export default DeliverySurchargeWarning
